export const HOST_UPDATE_REVIEW = "HOST_UPDATE_REVIEW"
export const HOST_UPDATE_REVIEW_SUCCESSFUL = "HOST_UPDATE_REVIEW_SUCCESSFUL"
export const HOST_UPDATE_REVIEW_FAILED = "HOST_UPDATE_REVIEW_FAILED"
export const HOST_UPDATE_REVIEW_RESET = "HOST_UPDATE_REVIEW_RESET"

